import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";

import { IoClose } from "react-icons/io5";
import { GoSearch } from "react-icons/go";

import "../Inventory/Inventory.css";
import "../Dashboard/Dashboard.css";
import "./Catalogue.css";
import productImg from "../../../assets/images/State-Distributor/inventoryProduct.png";
import placeholderImg from "../../../assets/images/previewPlaceholder.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import { axiosInstance } from "../../../axiosInstance";
import Pagination from "@mui/material/Pagination";
import Modal from "react-bootstrap/Modal";
import * as yup from "yup";

let addProductSchema = yup.object({
  // product_image: yup.string().required("Product image is required"),
  default_cost_price: yup.number().required("Default cost price is required"),
  // subdistributor_selling_price: yup
  //   .number()
  //   .required("Subdistributor price is required"),
  retail_selling_price: yup
    .number()
    .required("Retail selling price is required"),
});

export const SubCatalogue = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // // add product modal
  // const [showProductCode, setShowProductCode] = useState("");
  // const [addshow, setAddShow] = useState(false);

  // const handleAddClose = () => setAddShow(false);
  // const handleAddShow = (productCode) => {
  //   setAddShow(true);
  //   setShowProductCode(productCode);
  // };

  const [allProducts, setAllProducts] = useState({});

  // Filters
  const [selectedLabel, setSelectedLabel] = useState("");
  const [show, setShow] = useState(false);
  const [categoryToggler, setCategoryToggler] = useState("");
  const [searchText, setSearchText] = useState(""); // product name

  // pagination state
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const itemsPerPage = 5;

  const handleChange = (event, value) => {
    setPage(value);
  };

  async function FetchAllProducts() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: page + 1,
          search: searchText,
          category: categoryToggler,
          date: selectedLabel,
        },
      };
      const response = await axiosInstance.get(
        "inventory/subdistributor/product-list/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setAllProducts(response.data.data);
        setTotalPages(Math.ceil(response.data.data.count / itemsPerPage));
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch all products",
      );
      console.log("Failed to fetch all products");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    FetchAllProducts();
  }, [page]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (page !== 0) {
        setPage(0);
      } else {
        FetchAllProducts();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [categoryToggler, searchText, selectedLabel]);

  const handleClearFilters = () => {
    setSearchText("");
    setCategoryToggler("");
    setSelectedLabel("");
  };

  const handleReset = () => {
    setSearchText("");
  };

  //category
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategoryDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.status === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("category dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch category dropdown",
      );
      console.log("Failed to fetch category dropdown");
    }
  }
  useEffect(() => {
    LoadCategoryDropdown();
  }, []);

  // const formik = useFormik({
  //   initialValues: {
  //     // product_image: null,
  //     // product_name: "",
  //     product_code: "",
  //     // category: "",
  //     // uom: "",
  //     default_cost_price: "",
  //     // subdistributor_selling_price: "",
  //     retail_selling_price: "",
  //     min_stock_level: "",
  //     // isi_code: "",
  //     // package_size: "",
  //     // hs_code: "",
  //     // additional_notes: "",
  //   },
  //   validationSchema: addProductSchema,
  //   onSubmit: async (values, { resetForm }) => {
  //     try {
  //       setLoading(true);
  //       const formData = new FormData();
  //       // formData.append("product_image", values.product_image);
  //       // formData.append("product_name", values.product_name);
  //       formData.append("product_code", values.product_code);
  //       // formData.append("category", values.category);
  //       // formData.append("uom", values.uom);
  //       formData.append("default_cost_price", values.default_cost_price);
  //       // formData.append(
  //       //   "subdistributor_selling_price",
  //       //   values.subdistributor_selling_price
  //       // );
  //       formData.append("retail_selling_price", values.retail_selling_price);
  //       formData.append("min_stock_level", values.min_stock_level);
  //       // formData.append("isi_code", values.isi_code);
  //       // formData.append("package_size", values.package_size);
  //       // formData.append("hs_code", values.hs_code);
  //       // formData.append("additional_notes", values.additional_notes);

  //       const response = await axiosInstance.post(
  //         "inventory/subdistributor/product-create/",
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //           },
  //         }
  //       );
  //       if (response.data.status === "Success" || response.status === 200) {
  //         toast.success(response.data.message || "Product addded successfully");
  //         FetchAllProducts();
  //         resetForm();
  //         handleAddClose();
  //       }
  //     } catch (error) {
  //       toast.error("Failed to add product");
  //       console.log("Failed to add product");
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  // });
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="dashboardTitleContainer">
            <div>
              <div className="inventoryTitle">Catalogue</div>
              <div className="inventorySubtitle">
                View and manage your product catalogue with up-to-date stock
                details.
              </div>
            </div>
          </div>

          <div className="searchMainContainer">
            <div className="searchSubContainer">
              <div className="searchGrid">
                <div>
                  <input
                    type="text"
                    placeholder="Search by Product Name, Product Code"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </div>
                <div style={{ display: "flex", gap: "5px" }}>
                  <div>
                    <GoSearch className="searchIcon" />
                  </div>
                  <div className="btnRestSearch">
                    <button onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div>
              <div>
                <div className="dropdownTitle">Product Category</div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {categoryToggler || "All"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setCategoryToggler("")}>
                      All
                    </Dropdown.Item>
                    {categoryDropdown?.map((cat) => (
                      <Dropdown.Item
                        onClick={() => setCategoryToggler(cat.name)}
                      >
                        {cat.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <div className="dropdownTitle">Date Range</div>
                <Dropdown show={show} onToggle={() => setShow(!show)}>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {selectedLabel || "Select"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="dropdown-menu customDateMenu">
                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("7");
                      }}
                    >
                      Last 7 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("15");
                      }}
                    >
                      Last 15 days
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        setShow(false);
                        setSelectedLabel("30");
                      }}
                    >
                      Last 30 days
                    </Dropdown.Item>

                    <Dropdown.Item disabled>Custom Date :</Dropdown.Item>

                    <Dropdown.Item
                      as="div"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type="date"
                        className="form-control"
                        onChange={(e) => {
                          setShow(false); // close after selecting
                          setSelectedLabel(e.target.value);
                        }}
                      />
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>

          {(searchText || categoryToggler || selectedLabel) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {searchText && (
                  <>
                    {" "}
                    &nbsp; <strong>Product:</strong> {searchText}{" "}
                  </>
                )}

                {categoryToggler && categoryToggler !== "All" && (
                  <>
                    {" "}
                    , <strong>Category:</strong> {categoryToggler}{" "}
                  </>
                )}

                {selectedLabel && (
                  <>
                    {" "}
                    , <strong>Date:</strong> {selectedLabel}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
        </div>

        {/* cards section  */}
        <div className="catalogueCardsGrid">
          {allProducts?.results?.length > 0 ? (
            allProducts.results.map((product) => (
              <div className="catalogueCard" key={product.id}>
                <div className="catalogueImg">
                  <img src={product.product_image} alt={product.product_name} />
                </div>

                <div>
                  <div className="catalogueContent">
                    <span>Product Name :</span>
                    <span>{product.product_name}</span>
                  </div>

                  <div className="catalogueContent">
                    <span>Category :</span>
                    <span>{product.category}</span>
                  </div>

                  <div className="catalogueContent">
                    <span>Price :</span>
                    <span>
                      {Number(product.default_cost_price).toLocaleString(
                        "en-IN",
                        {
                          style: "currency",
                          currency: "INR",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        },
                      )}
                    </span>
                  </div>
                </div>

                <div className="d-flex gap-1">
                  <button
                    className="btnCatalogueViewMore"
                    onClick={() =>
                      navigate("/sub-view-catalogue", {
                        state: { id: product.id },
                      })
                    }
                  >
                    View More
                  </button>
                  {/* <button
                    className="btnCatalogueAdd"
                    onClick={() => handleAddShow(product.product_code)}
                  >
                    Add Product
                  </button> */}
                </div>
              </div>
            ))
          ) : (
            <div className="noData">Data Not Available</div>
          )}
        </div>

        <div className="paginationContainer">
          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChange}
              color="success"
            />
          </Stack>
        </div>

        {/* add product modal  */}
        {/* <div>
          <Modal
            show={addshow}
            onHide={handleAddClose}
            centered
            size="lg"
            className="addModal"
          >
            <form onSubmit={formik.handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add New Product
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>Product Code</label>
                       <input
                      type="text"
                      placeholder="Enter Product Code"
                      name="product_code"
                      value={formik.values.product_code}
                      onChange={formik.handleChange}
                    /> 
                    <select
                      onChange={formik.handleChange}
                      name="product_code"
                      value={formik.values.product_code}
                    >
                      <option value="" selected disabled>
                        Select
                      </option>

                      {dropdownProductcode?.length > 0 ? (
                        dropdownProductcode?.map((pro) => (
                          <option value={pro.product_code}>
                            {pro.product_code}
                          </option>
                        ))
                      ) : (
                        <option disabled>Data not available</option>
                      )}
                    </select>
                  </div>
                  <div>
                    <label>Min Stock Level</label>
                    <input
                      type="number"
                      placeholder="Enter min stock level"
                      name="min_stock_level"
                      value={formik.values.min_stock_level}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>

                <div className="addModalGrid">
                  <div>
                    <label>Default Cost Price (₹)</label>
                    <input
                      type="number"
                      placeholder="Enter Price"
                      name="default_cost_price"
                      value={formik.values.default_cost_price}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.default_cost_price &&
                      formik.touched.default_cost_price && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.default_cost_price}
                        </div>
                      )}
                  </div>
                  <div>
                    <label>Retail Selling Price</label>
                    <input
                      type="number"
                      placeholder="Enter Selling Price"
                      name="retail_selling_price"
                      value={formik.values.retail_selling_price}
                      onChange={formik.handleChange}
                    />
                    {formik.errors.retail_selling_price &&
                      formik.touched.retail_selling_price && (
                        <div
                          className="text-danger"
                          style={{ fontSize: "12px" }}
                        >
                          {formik.errors.retail_selling_price}
                        </div>
                      )}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleAddClose}
                >
                  Cancel
                </button>
                <button className="addBtnSave" type="submit">
                  {" "}
                  Save Product
                </button>
              </Modal.Footer>
            </form>
          </Modal>
        </div> */}
      </div>
    </>
  );
};
